import { EditorialMarquee } from "../sections/EditorialMarquee";
import { Manifesto } from "../sections/Manifesto";
import { FeaturedWork } from "../sections/FeaturedWork";
import { ServicesPreview } from "../sections/ServicesPreview";
import { AboutPreview } from "../sections/AboutPreview";
import { Testimonials } from "../sections/Testimonials";
import { useSEO } from "../lib/useSEO";

export default function Home() {
  useSEO({
    title: "Wedding Photographer Chester & Cheshire | Jason Howard Photography",
    description:
      "Natural, relaxed wedding photography for couples across Cheshire, Liverpool, Manchester & North Wales. 20+ years, 170+ 5-star reviews.",
    canonical: "https://jasonhowardphotography.co.uk/",
  });
  return (
    <>
      {/* The hero is static HTML in public/index.html (#jh-hero) so the largest
          paint never waits for JS — React never re-renders it. */}
      <EditorialMarquee />
      <Manifesto />
      <FeaturedWork />
      <ServicesPreview />
      <AboutPreview />
      <Testimonials />
      <EditorialMarquee />
    </>
  );
}
